import Crud from '../views/Types/Crud'
import Entity from '../views/Types/Add'

let routes = {
    path: '/types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/types/add',
            name: 'NewTypes',
            component: Entity,
            meta: {
                pageTitle: 'Tipos',
                breadcrumb: [
                    {
                        text: 'Adicionar Tipo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/types/edit/:id?',
            name: 'EditTypes',
            component: Entity,
            meta: {
                pageTitle: 'Tipos',
                breadcrumb: [
                    {
                        text: 'Editar Tipo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/types',
            name: 'list-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos',
                breadcrumb: [
                    {
                        text: 'Tipos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
